import React from "react";
import "./Ethics.css";
import ethicsImage from "../assets/images/ethics.jpg";

const Ethics = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="ethics-hero"
        style={{ backgroundImage: `url(${ethicsImage})` }}
      >
        <div className="ethics-hero-overlay" />

        <div className="ethics-hero-content">
          <h1 className="ethics-hero-title">
            <span className="green">Ethics</span>{" "}
            <span className="purple">and transparency</span>
          </h1>
        </div>
      </section>
      {/* ================= CORPORATE CODE SECTION ================= */}
<section className="code-section">
  <div className="code-grid">

    {/* LEFT IMAGE */}
    <div className="code-image">
      <img src={require("../assets/images/code-book.jpg")} alt="Corporate code" />
    </div>

    {/* RIGHT CONTENT */}
    <div className="code-content">

      <h2 className="code-title">
        <span className="green">Corporate</span>{" "}
        <span className="purple">code of conduct</span>
      </h2>

      <p>
        We believe in the importance of being a solid company based on ethical
        and sustainable growth in all areas: financial, social, environmental
        and governance.
      </p>

      <p>
        To achieve that, we implement strict quality systems and policies that
        guarantee ethics, human rights and good practice within our organisation.
      </p>

      <h3 className="code-subtitle">
        <span className="green">We are</span>{" "}
        <span className="purple">governed by:</span>
      </h3>

      <div className="code-icons">

        <div className="code-item">
          <div className="code-icon">✔</div>
          <p>
            The <strong>quality of our products</strong> as a principle
          </p>
        </div>

        <div className="code-item">
          <div className="code-icon">📊</div>
          <p>
            <strong>Economic sustainability and financial integrity</strong>
          </p>
        </div>

        <div className="code-item">
          <div className="code-icon">🌱</div>
          <p>
            Commitment to <strong>society and the environment</strong>
          </p>
        </div>

      </div>

      <button className="code-button">Code of conduct</button>

    </div>
  </div>
</section>
{/* ================= REPORTING & SUSTAINABILITY ================= */}
<section className="report-section">
  <div className="report-container">

    {/* ROW 1 */}
    <div className="report-row">
      <div className="report-left">
        <h2 className="report-title">
          <span className="green">Reporting</span>{" "}
          <span className="purple">channel</span>
        </h2>
         <p>
          Under our Compliance Policy and pursuant to applicable regulations,
          Batterjee Group has an accessible Internal Information System for reporting
          any breach or suspected breach of regulations.
        </p>
      </div>

      <div className="report-right">
       

        <p>
          This reporting channel can be used by both the people who work for
          companies in the batterjee Group and anyone else with links to those
          companies, either openly (albeit confidentially) or anonymously.
        </p>

        <button className="outline-btn">Reporting channel</button>
      </div>
    </div>

    {/* ROW 2 */}
    <div className="report-row">
      <div className="report-left">
        <h2 className="report-title">
          <span className="green">Batterjee Group</span>{" "}
          <span className="purple">Sustainability Report</span>
        </h2>
      </div>

      <div className="report-right">
        <p>
          Our Sustainability Report contains information on all those non-financial
          issues that also form part of the commitments made by Batterjee Group, in
          line with the United Nations Sustainable Development Goals (SDG). It
          therefore includes and summarises our main actions and indicators
          referring to social, environmental, ethical and governance matters.
        </p>

        <button className="outline-btn download-btn">
          Download summary
        </button>
      </div>
    </div>

  </div>
</section>
{/* ================= COMMITMENTS ================= */}
<section className="commitments-section">
  <h2 className="commitments-title">
    <span className="green">Our</span>{" "}
    <span className="purple">commitments</span>
  </h2>

  <div className="commitments-list">
    <span className="commitment-pill green-border">People move us</span>
    <span className="commitment-pill purple-border">Ethics and transparency</span>
    <span className="commitment-pill green-border">Environmental commitment</span>
    <span className="commitment-pill purple-border">
      Sustainable economic development
    </span>
  </div>
</section>
    </>
  );
};

export default Ethics;